export default "__VITE_ASSET__DYmsv9Q2__"